<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item label="业务板块" prop="type_name" 
                :rules="[
                { required: true, message: '请选择业务板块' },
              ]">
              <el-radio-group v-model="formData.type_name">
                <el-radio label="竞赛">竞赛</el-radio> 
                <el-radio label="培训">培训</el-radio> 
                <el-radio label="星级俱乐部">星级俱乐部</el-radio> 
                <el-radio label="七彩星级">七彩星级</el-radio> 
                <el-radio label="其他">其他</el-radio> 
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="是否匿名"
                prop="niming" 
            >
              <el-radio-group v-model="formData.niming">
                <el-radio :label="1">匿名</el-radio> 
                <el-radio :label="2">实名</el-radio>  
              </el-radio-group>
            </el-form-item>
          </el-col> 
        </el-row> 


        <el-row :gutter="20">
          <el-col :span="12">
            
            <el-form-item
                label="意见或建议"
                prop="content"
                :rules="[
                { required: true, message: '请输入详细地址', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.content"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入您的意见或建议..."
              ></el-input>
            </el-form-item>
          </el-col>
  
        </el-row>
 
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交报名
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
 
  </div>

      <el-dialog
          title="信箱@CCA"
          :visible.sync="showNotice"
          width="40%"
          center
      >
        <div class="notice_content">
  <p>欢迎您@CCA。您对啦啦操竞赛、培训、星级俱乐部、七彩星级有什么感受？您对啦啦操项目推广及未来发展有何高招与高见？啦啦操离不开大家的真知灼见。</p>
  <p>您的留言将被转给有关业务部门和地方，并可能以不同形式公开。</p>
  <p>汲取各方智慧，倾听阁下意见，采纳诸君建议。您对啦啦操的期望，也是我们努力的方向。</p>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showNotice = false">信箱入口</el-button>
          <el-button @click="back()">取 消</el-button>
        </span>
      </el-dialog>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.notice_content{
    padding: 10px;
    text-align: left;
    line-height: 28px;
}
.notice_content p{
    text-indent:2em;
    margin-bottom: 1em;
}
.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue'; 
import validator from "../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button, Dialog
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'DakejianApplySimple',
  components: {
    PicUploader, LoginDialog,SaiquPicker
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      showNotice: false,
      saveLoading: false,
      showArea: false,
      showSaiquPicker:false,
      showDate: false,
      areaList: {},
      areaOptions: [],
      areaValue: '',
      submitType: '',

      minDate: new Date( ),
      formData: {
        id: 0,
        year: '',
        niming:2,
        type: 1,
        address: '',
        extra_saiqu: [],
        huodongpic: [],
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = '大课间申报'
 
    that.formData.id = this.$route.query.id;
    that.getUserDetail();  
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {  
    getUserDetail() {
      let that = this;
      this.$api.get('/api/user/userPage', {}, (res) => {
        console.log(res)
        that.showNotice =true;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        } else {
          Toast(res.msg)
        }
      })
    },
    back(){
        rbLink({
                name:'',
            },'back')
    },
 
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    }, 

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName])
      that.$refs[formName].validate((valid) => {
        if (valid) { 
          that.saveLoading = true;
          that.$api.post('/api/gbook/formadd', that.formData, (res) => {
            that.saveLoading = false;
            that.$message.success('提交成功，感谢您的宝贵建议~'); 
          setTimeout(() =>{
            rbLink({
            name:'' 
            },'back')
          },1000)
          }, (res) => {
 
            that.$message.warning(res.msg);
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },

  }
}
</script>



// WEBPACK FOOTER //
// Gbook.vue?7afcf6b0